import React from 'react';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core';
import styles from './styles.scss';

interface CommentDropdownProps {
    options: Map<string, string>,
    testid: string,
    selectHandler: (value: string) => void,
    selectedValue: string,
}

/* CommentDropdown receive options and display dropdown with comment filter options */
const CommentDropdown = ({ options, selectHandler, selectedValue, testid = '' }: CommentDropdownProps) => {
    const styleOverride = makeStyles({
        // this is needed to override MUI base styles
        root: {
            '& .MuiInput-root': {
                fontSize: 14,
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingLeft: 10,
            },
            '& .MuiSelect-select:focus': {
                background: 'transparent',
            },
            '& .MuiList-padding': {
                padding: 0,
            },
            '& .MuiInput-underline:before': {
                borderBottom: 'none',
            },
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottom: 'none',
                transition: 'none',
            },
            '& .MuiInput-underline:after': {
                borderBottom: 'none',
                transition: 'none',
            },
        },
    })().root;

    return (
        <div className={styles['comment-dropdown-container']}>
            <FormControl className={`${styleOverride} ${styles['comment-dropdown']}`}>
                <Select
                    data-testid={testid}
                    onChange={(event: React.ChangeEvent<{ name?: string | undefined, value: unknown }>) => {
                        const value = event.target.value as string;
                        return selectHandler(value);
                    }}
                    labelWidth={10}
                    native
                    value={selectedValue}
                >
                    {[...options.keys()].map((key: string) => <option value={key} key={key}>{options.get(key)}</option>)}
                </Select>
            </FormControl>
        </div>
    );
};

export default CommentDropdown;